/**
 * Cart bridge for custom add-to-cart flows.
 *
 * The custom PDP and landing sections (agen-supp-pdp, agen-robot-pdp,
 * agen-band-pdp, the lp-* landings, …) add to cart with a raw
 * fetch('/cart/add') and only show a toast — the Horizon drawer, header
 * count and upsell carousel never hear about it, so they stay stale until
 * a full page refresh.
 *
 * This shim watches fetch for successful /cart/add calls that did NOT come
 * from the theme's own forms (those include a `sections` param and already
 * dispatch cart:update themselves) and dispatches the theme's cart:update
 * event. cart-items-component then re-renders the drawer via the Section
 * Rendering API (cache: false), and cart-drawer-component auto-opens when
 * the "auto-open" setting is on — identical to a native add.
 */
(function () {
  'use strict';

  if (window.__agenCartBridge) return;
  window.__agenCartBridge = true;

  var origFetch = window.fetch;

  function isCartAdd(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  // Native theme forms bundle a `sections` param and handle their own
  // cart:update dispatch — the bridge must not double-fire for those.
  function hasSectionsParam(init) {
    var body = init && init.body;
    if (!body) return false;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      try {
        return body.has('sections');
      } catch (e) {
        return false;
      }
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return body.has('sections');
    }
    if (typeof body === 'string') return body.indexOf('sections') !== -1;
    return false;
  }

  window.fetch = function (input, init) {
    var result = origFetch.apply(this, arguments);
    try {
      if (isCartAdd(input) && !hasSectionsParam(init)) {
        result = result.then(function (response) {
          if (response.ok) {
            setTimeout(function () {
              try {
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: null,
                      sourceId: 'agen-cart-bridge',
                      data: { source: 'agen-cart-bridge' },
                    },
                  })
                );
              } catch (e) {
                /* never break the caller's add flow */
              }
            }, 0);
          }
          return response;
        });
      }
    } catch (e) {
      /* fall through with the untouched promise */
    }
    return result;
  };
})();
